module.exports = __webpack_public_path__ + "img/sm_01_youtube.e7dcf33a.svg";